import { Bell } from "lucide-react";
import { type FC } from "react";

import { m } from "@recobra/i18n/messages";
import type { NotificationFilter } from "@recobra/schemas/notification";
import { Empty, EmptyDescription, EmptyMedia } from "@recobra/ui/empty";

export const NotificationEmptyState: FC<{ filter: NotificationFilter }> = ({ filter }) => {
  const description = EMPTY_DESCRIPTIONS[filter]();

  return (
    <Empty>
      <EmptyMedia variant="icon">
        <Bell />
      </EmptyMedia>
      <EmptyDescription>{description}</EmptyDescription>
    </Empty>
  );
};

const EMPTY_DESCRIPTIONS: Record<NotificationFilter, () => string> = {
  all: m.notifications_empty_all,
  unread: m.notifications_empty_unread,
  mention: m.notifications_empty_mentions,
  system: m.notifications_empty_system,
};
